import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SecondaryButton from '../../common/buttons/SecondaryButton';
import './RefereeDeclined.less';
import RefereePageLayout from '../../layouts/RefereePageLayout';
import { getUniqueQueryString, hasValue } from '../../../lib/utils';
import { useAsyncAction } from '../../../commonComponents/Hooks';
import { setRefereeConsent } from '../../../core/api';

const RefereeDeclined = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [, , performAsyncAction] = useAsyncAction();
	const token = getUniqueQueryString(location.search, 'token');
	const handleResumeClicked = () => {
		navigate('/referee/validation');
	};

	React.useEffect(() => {
		if (hasValue(token)) {
			performAsyncAction(async () => {
				await setRefereeConsent(token, false);
			});
		}
	}, []);

	return (
		<>
			<RefereePageLayout className="refereeDeclinedPage" title="Declined">
				<h2>You have declined.</h2>
				<p>
					We&apos;ve informed the interested parties about your decision. If you change your mind, resume your reference
					below or click the link your originally received.
				</p>
				<SecondaryButton text="Resume" onClick={handleResumeClicked} />
			</RefereePageLayout>
		</>
	);
};

export default RefereeDeclined;
